namespace SorAraBul.Administration {

    @Serenity.Decorators.registerEditor()
    export class CreditPaymentOrderStatusEditor extends Serenity.Select2Editor<any, any> {
        constructor(container: JQuery) {
            super(container, null);

            this.addOption("Pending", "Pending");
            this.addOption("Paid", "Paid");
            this.addOption("Failed", "Failed");
        }
    }
}
